import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Menu } from 'antd';
import IntlMessages from "../../components/utility/intlMessages";
import DvFontAwesome from "../../components/uielements/dvFontAwesome";


function HamburgerMenu(props) {
  function navigateTo(page) {
    props.history.push(`/Dashboard/${page}`)
  }

  return (
    <Menu theme="light" mode="inline">
      <Menu.Item key="homePage" icon={<DvFontAwesome icon="home" />} onClick={() => navigateTo('home')}>
        <IntlMessages id="sider.hamburgerMenu.homePage" />
      </Menu.Item>
      <Menu.Item key="clinics" icon={<DvFontAwesome icon="hospital-symbol" />} onClick={() => navigateTo('clinics')}>
        <IntlMessages id="sider.hamburgerMenu.clinics" />
      </Menu.Item>
      <Menu.Item key="dailyStatistics" icon={<DvFontAwesome icon="chart-bar" />} onClick={() => navigateTo('dailyStatistics')}>
        <IntlMessages id="sider.hamburgerMenu.dailyStatistics" />
      </Menu.Item>
      <Menu.Item key="databases" icon={<DvFontAwesome icon="database" />} onClick={() => navigateTo('databases')}>
        <IntlMessages id="sider.hamburgerMenu.databases" />
      </Menu.Item>
      <Menu.Item key="backups" icon={<DvFontAwesome icon="hdd" />} onClick={() => navigateTo('backups')}>
        <IntlMessages id="sider.hamburgerMenu.backups" />
      </Menu.Item>
      <Menu.Item key="logs" icon={<DvFontAwesome icon="clipboard-list" />} onClick={() => navigateTo('logs')}>
        <IntlMessages id="sider.hamburgerMenu.logs" />
      </Menu.Item>
      <Menu.Item key="auditLogs" icon={<DvFontAwesome icon="clipboard-list" />} onClick={() => navigateTo('auditLogs')}>
        <IntlMessages id="general.auditLogs" />
      </Menu.Item>
      <Menu.Item key="icmd" icon={<DvFontAwesome icon="microchip" />} onClick={() => navigateTo('icmd')}>
        <IntlMessages id="general.icmd" />
      </Menu.Item>
      <Menu.Item key="aiClinician" icon={<DvFontAwesome icon="user-nurse" />} onClick={() => navigateTo('aiClinician')}>
        <IntlMessages id="general.aiClinician"/>
      </Menu.Item>
    </Menu>
  )
}

HamburgerMenu.propTypes = {
};

const mapActionsToProps = {
};

function mapStateToProps(state) {
  return {
  };
}

const wrappedHamburgerMenu = withRouter(HamburgerMenu);
const connectedApp = connect(mapStateToProps, mapActionsToProps)(wrappedHamburgerMenu);
export default connectedApp;
